import apiClient from '@/axios';

export default {
  async getAnalytics(params = {}) {
    const { data } = await apiClient.get('/admin/getadmin', { params });
    return data;
  },
};
